export const getLoading = (state) => state.bookingReviews.loading;
export const getForm = (state) => state.bookingReviews.form;
export const getData = (state) => state.bookingReviews.data;
export const getOpen = (state) => state.bookingReviews.open;
